import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Directives
// Material Modules
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

// Custom Modules & Services
import { PageModule, SpinnerModule, UtilsModule } from '@gallaghercp/core-frontend';
import { SwiperModule } from '@gallaghercp/core-swiper';
import { TranslateModule } from '@ngx-translate/core';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';

// Bootstrap Modules
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

// App Components
import { MainComponent } from './main/main.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { SideNavFooterComponent } from './nav/side-nav/side-nav-footer/side-nav-footer.component';
import { SideNavComponent } from './nav/side-nav/side-nav.component';
import { PostThumbnailsComponent } from './nav/top-nav/post-thumbnails/post-thumbnails.component';
import { TopNavComponent } from './nav/top-nav/top-nav.component';
import { OopsComponent } from './oops/oops.component';
import { PostComponent } from './post/post.component';

@NgModule({
    declarations: [
        MainComponent,
        MaintenanceComponent,
        OopsComponent,
        HeaderComponent,
        FooterComponent,
        SideNavComponent,
        SideNavFooterComponent,
        TopNavComponent,
        PostComponent,
        PostThumbnailsComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        BsDropdownModule,
        CollapseModule,
        ModalModule,
        ButtonsModule,
        CarouselModule,
        TabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        SpinnerModule,
        AlertModule,
        TranslateModule,
        MatTabsModule,
        PageModule,
        MatExpansionModule,
        UtilsModule,
        TooltipModule,
        SwiperModule,
    ],
    exports: [MainComponent, CommonModule, HeaderComponent, FooterComponent, SideNavComponent, PostThumbnailsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {
    constructor() {}
}
